<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <base-header class="pb-6">
      <h2 slot="header" class="mb-0">Manage User Agreement</h2>
    </base-header>

    <div class="container-fluid mt--6">
      <card>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form @submit.prevent="handleSubmit(submit)">
            <div class="form-row flex-layout gap-30">
              <!-- Title -->
              <div class="col-md-12 flex-layout">
                <label class="form-control-label">Title *</label>
                <input
                  v-model="form.title"
                  type="text"
                  class="form-control"
                  placeholder="Enter agreement title"
                  required
                />
                <div class="text-danger">{{ formErrors?.title?.[0] }}</div>
              </div>

              <!-- Content -->
              <div class="col-md-12 flex-layout">
                <label class="form-control-label">Content *</label>
                <vue-editor
                  v-model="form.content"
                  :editorOptions="editorOptions"
                  class="rich-editor"
                />
              </div>
              <div class="text-danger">{{ formErrors?.content?.[0] }}</div>
              <!-- Active Toggle -->
              <div class="col-md-4 flex-layout">
                <label class="form-control-label">Active</label>
                <el-switch
                  v-model="form.status"
                  :active-value="1"
                  :inactive-value="0"
                />

              </div>
            </div>

            <div class="text-right mt-4">
              <base-button type="primary" native-type="submit">
                Save Agreement
              </base-button>
            </div>
          </form>
        </validation-observer>
      </card>
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { VueEditor } from "vue2-editor";
import { Switch } from "element-ui";

export default {
  components: {
    ValidationObserver,
    [Switch.name]: Switch,
    VueEditor,
  },
  data() {
    return {
      loading: false,
      form: {
        title: "",
        content: "",
        status: 0,
      },
      formErrors:{},
      editorOptions: {
        // optional: configure editor toolbar
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
            ["clean"],
          ],
        },
      },
    };
  },
  mounted() {
    this.fetchAgreement();
  },
  methods: {
    async fetchAgreement() {
      this.loading = true;
      try {
        const { data } = await this.$http.get("agreement/get");
        if (data.status) {
          this.form = {
            title: data.data.title || "",
            content: data.data.content || "",
            status: data.data.status ?? 1,
          };
        }
      } catch (err) {
        this.$toast.error("Failed to load agreement");
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      this.loading = true;
      const cleanedContent = this.form.content.replace(/<(.|\n)*?>/g, "").trim();
      if (!this.form.title || !cleanedContent) {
        this.$toast.error("Please fill all required fields.");
        this.loading = false;
        return;
      }

      try {
        const { data } = await this.$http.post("agreement/update", this.form);
        if (data.status) {


          this.$toast.success("Agreement updated successfully", {
            timeout: 5000,
            toastClassName: "scorm-error-toast",
          });
        }else {
          this.formErrors = data.additionalErrors
        }
      } catch (err) {
        const msg = err.response?.data?.message || "Save failed";
        this.$toast.error(msg, {
          timeout: 5000,
          toastClassName: "scorm-error-toast",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.content {
  padding-top: 1rem;
}
.mb-3 {
  margin-bottom: 1rem;
}
.flex-layout {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.gap-30 {
  gap: 30px !important;
}
</style>
